<template>
  <div>
    <h4 class="mb-1">
      {{ config.title }}
    </h4>
    <a
      v-for="appLink in config.appLinks"
      :key="appLink.name"
      v-tealium:click="createStats(appLink.statName, getLink(appLink.linkRef))"
      :data-wptv="appLink.dataWptv"
      :href="getLink(appLink.linkRef)"
      target="_blank">
      <img
        :src="appLink.imageLocation"
        :alt="appLink.alt"
        width="150px"
        height="50px">
    </a>
  </div>
</template>

<script>
import _get from 'lodash/get'

export default {
  name: 'MobileAppSection',
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  methods: {
    getLink (linkRef) {
      return _get(this.$config, linkRef)
    },
    createStats (name, cible) {
      return {
        track_page: 'home',
        track_zone: 'footer',
        track_nom: name,
        track_cible: cible,
        track_type: 'clic'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../scss/abstracts/variables';
  @import '../../../scss/abstracts/mixins';

  a:not(:last-child) {
    margin-right: 15px;
  }
  img {
    height: 50px;
    @include mediaQueries('height', (medium: 54px, xlarge: 59px));
    width: 150px;
    @include mediaQueries('width', (medium: 164px, xlarge: 178px));
  }
</style>
